module.exports = shared.Extend;